import React from "react";
import { Typography } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";

const BuySellDetailsMRT = (props) => {
    const {
        price, margin, totalPrice, currency, deliveryPoint, contractHours, notionalValue, lastUpdated
    } = props;

    // Creating data as rows with label and value
    const data = React.useMemo(() => [
        { field: 'Price', value: price || '-' },
        { field: 'Margin', value: margin || 0 },
        { field: 'Total Price', value: totalPrice || '-' },
        { field: 'Currency', value: currency || '-' },
        { field: 'Delivery Point', value: deliveryPoint || '-' },
        { field: 'Contract Hours', value: contractHours || '-' },
        { field: 'Notional Value', value: notionalValue || 0 },
        { field: 'Last Updated', value: lastUpdated || '-' }
    ], [price, margin, totalPrice, currency, deliveryPoint, contractHours, notionalValue, lastUpdated]);

    const columns = React.useMemo(
        () => [
            {
                header: "Field",
                accessorKey: "field",
                size: 150,
                Cell: ({ cell }) => (
                    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#245372' }}>
                        {cell.getValue()}
                    </Typography>
                )
            },
            {
                header: "Value",
                accessorKey: "value",
                size: 200,
                Cell: ({ cell }) => (
                    <Typography sx={{ fontSize: '14px' }}>
                        {cell.getValue()}
                    </Typography>
                )
            }
        ],
        []
    );

    const table = useMaterialReactTable({
        columns,
        data,
        enablePagination: false,
        enableBottomToolbar: false,
        enableTopToolbar: true,
        enableColumnActions: false,
        enableSorting: false,
        enableFilters: false,
        enableGlobalFilter: false,
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        enableHiding: false,
        initialState: {
            density: 'compact',
        },
        renderTopToolbarCustomActions: () => (
            <Typography component="span" variant="h6" color={'#245372'} sx={{ fontWeight: 600 }}>
                Contract Details
            </Typography>
        ),
        muiTableProps: {
            onMouseDown: (event) => {
                event.stopPropagation();
            }
        },
        muiTableContainerProps: {
            sx: {
                maxHeight: '400px',
            }
        },
        muiTableHeadRowProps: {
            sx: {
                backgroundColor: '#CBF0E6',
            }
        },
        muiTableHeadCellProps: {
            align: 'left',
            sx: {
                color: '#245372',
                borderTop: '2px solid #3DC3C1',
                borderBottom: '2px solid #3DC3C1',
                fontSize: '14px',
                fontWeight: 600,
                padding: '8px 16px'
            }
        },
        muiTableBodyCellProps: {
            align: 'left',
            sx: {
                fontSize: '14px',
                padding: '8px 16px'
            }
        }
    });

    return (
        <MaterialReactTable table={table} />
    );
};

export default BuySellDetailsMRT;
